<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_organization_code') || '机构编码'"
            prop="orgNo"
          >
            <el-input
              clearable
              v-model="formData.orgNo"
              :placeholder="
                $l('form_label_please_organization_code') ||
                  '请输入机构编码'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 16 }" :lg="{ span: 16 }">
          <el-form-item
            :label="$l('form_label_organization_name') || '机构名称'"
            prop="orgName"
          >
            <el-input
              clearable
              v-model="formData.orgName"
              :placeholder="
                $l('form_label_pleaseEnter_organization_name') ||
                  '请输入机构名称'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_Provinces_cities_counties') || '省市区县'"
          >
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 16 }" :lg="{ span: 16 }">
          <el-form-item
            :label="$l('form_label_detailed_address') || '详细地址'"
          >
            <el-input
              clearable
              v-model="formData.orgAddress"
              :placeholder="
                $l('table_label_Please_enter_your_full_address') ||
                  '请输入详细地址'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('form_label_valid_status') || '有效状态'"
          required
        >
          <el-col>
            <el-radio-group v-model="formData.orgStatus">
              <el-radio label="Y">{{
                $l('from_radio_effective') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    orgCode: String
  },
  data() {
    return {
      regionShow: false,
      formData: { orgStatus: 'Y' },
      rules: {
        orgNo: [
          {
            required: true,
            message:
              this.$l('form_label_please_organization_code') ||
              '请输入机构编码',
            trigger: 'blur'
          }
        ],
        orgName: [
          {
            required: true,
            message:
              this.$l('form_label_pleaseEnter_organization_name') ||
              '请输入机构名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      if (!this.orgCode) return
      this.$api
        .sysOrganizationDetailApi({
          orgCode: this.orgCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .sysOrganizationSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success'
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          } else {
            return
          }
        })
    }
  }
}
</script>
